module.exports = __webpack_public_path__ + "img/sol_isol_pain4.b514a0a0.png";